import {
  Button,
  Field,
  Input,
  Switch,
  Textarea,
  Tooltip,
} from "@fluentui/react-components";
import { AddRegular } from "@fluentui/react-icons";
import { useStyles } from "./EditProjectIqWorkspaceDialog.styles";
import { ICustomCapabilityAddCardProps } from "./CustomCapabilityAddCard.types";

export const CustomCapabilityAddCard = ({
  isExpanded,
  form,
  formErrors,
  isSaving,
  onExpand,
  onChange,
  onEnabledChange,
  onSave,
  onCancel,
}: ICustomCapabilityAddCardProps): JSX.Element => {
  const styles = useStyles();

  if (isExpanded) {
    return (
      <div className={styles.addCapCardExpanded}>
        <div className={styles.inlineFormRow}>
          <Field
            label="Name"
            required
            validationState={formErrors.name ? "error" : "none"}
            validationMessage={formErrors.name}
          >
            <Input
              value={form.name}
              onChange={(_e, data) => onChange("name", data.value)}
              placeholder="Enter capability name"
              disabled={isSaving}
            />
          </Field>
          <Tooltip
            content={form.url || "No URL entered"}
            relationship="description"
          >
            <Field
              label="URL"
              required
              validationState={formErrors.url ? "error" : "none"}
              validationMessage={formErrors.url}
            >
              <Input
                value={form.url}
                onChange={(_e, data) => onChange("url", data.value)}
                placeholder="https://example.com"
                disabled={isSaving}
              />
            </Field>
          </Tooltip>
        </div>
        <Field label="Description">
          <Textarea
            value={form.description}
            onChange={(_e, data) => onChange("description", data.value)}
            placeholder="Enter optional description"
            rows={2}
            disabled={isSaving}
          />
        </Field>
        <div className={styles.inlineFormActions}>
          <Switch
            label="Enabled"
            checked={form.isEnabled}
            onChange={(_e, data) => onEnabledChange(data.checked)}
            disabled={isSaving}
          />
          <div className={styles.inlineFormButtons}>
            <Button appearance="outline" onClick={onCancel} disabled={isSaving}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={onSave} disabled={isSaving}>
              Add capability
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.addCapCard}
      onClick={onExpand}
      role="button"
      tabIndex={0}
      aria-label="Add custom capability"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onExpand();
        }
      }}
    >
      <AddRegular />
      <span>Add custom capability</span>
    </div>
  );
};
